import './themed-select.module.css';

export const THEMED_SELECT_CLASS_NAME_PREFIX = 'themed-select';
